<div class="flex flex-col h-full bg-app-gray-3 basic-shadow {{ isSidebarOpen ? 'w-[200px]' : 'w-[60px]' }}">
   @for (item of navBarItems$ | async; track item) {
      <div
         class=" border-b border-white flex flex-col cursor-pointer {{ item.selected ? 'bg-white text-app-accent-2' : 'text-app-primary-1' }} nav-item"
         (mouseenter)="preloadItem(item)"
         (click)="handleItemClick(item); $event.stopPropagation()"
      >
         <div class="flex px-5 items-center gap-4 flex-1 min-h-[40px]">
            @if (item.icon) {
               <span
                  class="h-[24px] w-[24px] min-h-[24px] min-w-[24px] {{ item.selected ? 'fill-app-accent-2' : 'fill-app-primary-1' }}"
                  [inlineSVG]="item.icon"
               ></span>
            }
            @if (isSidebarOpen) {
               <span
                  @inOut
                  class="text-xs whitespace-nowrap flex-1"
                  >{{ item.label | translate }}</span
               >
            }
            @if (isSidebarOpen) {
               <i
                  @inOut
                  class="{{ item.selected ? 'flex' : 'hidden' }} pi text-[13px]  justify-end macro-item-icon {{
                     item.subItems ? (item.subItemsIsOpen ? '' : 'pi-chevron-down') : 'pi-chevron-right'
                  }}"
               ></i>
            }
         </div>
         @if (item.subItems && item.subItemsIsOpen && isSidebarOpen) {
            <div
               @inOut
               class="flex flex-col border-t border-app-gray-3"
            >
               @for (submenuItem of item.subItems; track submenuItem) {
                  <div
                     class="flex px-5 py-[6px] border-b border-app-gray-3 items-center sub-item cursor-pointer gap-2"
                     (click)="submenuItem.goTo(); submenuItem.selected = true; $event.stopPropagation()"
                  >
                     <i class="{{ submenuItem.selected ? 'flex' : 'hidden' }} pi pi-chevron-right text-[13px]  justify-end"></i>
                     <span class=" flex-1 text-xs  whitespace-nowrap {{ submenuItem.selected ? 'font-black' : 'text-app-primary-1' }}">{{
                        submenuItem.label | translate
                     }}</span>
                  </div>
               }
            </div>
         }
      </div>
   }
</div>
